var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modals-header',_vm._b({},'modals-header',_vm.$attrs,false),[_c('svg-exclamation-triangle'),_vm._v("\n\tConfirmation Required\n")],1)}
var staticRenderFns = []

export { render, staticRenderFns }